import React, { useEffect, useRef, useState } from 'react';
import { ModelService } from '../utils/ModelService';
import Wrapper from '../ui/Wrapper';
import { connect } from 'react-redux';
import ViewSpinner from '../components/ViewSpinner';
import ViewListToolbar from '../components/ViewToolbars/ViewListToolbar';
import ViewEventList from './ViewEventList/ViewEventListNew';
import { boxFlex, BoxRoundedBorderBottom } from '../styled';
import styled from 'styled-components';
import { NoEventsMessageBlue } from '../components/NoEventsMessage';

const SearchEventsWrapper = styled(boxFlex)`
    gap: 16px;
`;

const SearchEventsView = ({
    sportData,
    liveEvents,
    preEvents,
    overviewSearchEvents,
}) => {
    const [isEventsLoading, setIsEventsLoading] = useState(true);
    const wasPending = useRef(false);

    useEffect(
        () => {
            if (overviewSearchEvents.pending) {
                setIsEventsLoading(true);
            }

            if (wasPending.current && !overviewSearchEvents.pending) {
                setIsEventsLoading(false);
            }

            wasPending.current = overviewSearchEvents.pending;
        },
        [overviewSearchEvents.pending]
    );

    if (isEventsLoading) {
        return (
            <Wrapper position={'relative'} minHeight={'350px'}>
                <div className="search-box-spinner">
                    <ViewSpinner />
                </div>
            </Wrapper>
        );
    }

    const getView = (events) => {
        return (
            <BoxRoundedBorderBottom>
                {events.length > 0 ? (
                    <ViewEventList
                        events={ModelService.getSportTree(
                            sportData,
                            events,
                            'array',
                            0,
                            null,
                            'sportId'
                        )}
                    />
                ) : (
                    <NoEventsMessageBlue />
                )}
            </BoxRoundedBorderBottom>
        );
    };

    return (
        <SearchEventsWrapper>
            <section>
                <ViewListToolbar title="Live" icon={'live'} />
                {getView(liveEvents)}
            </section>

            <section>
                <ViewListToolbar title="Pre" />
                {getView(preEvents)}
            </section>
        </SearchEventsWrapper>
    );
};

const mapStateToProps = (state) => {
    return {
        overviewSearchEvents: state.overviewSearchEvents,
    };
};

export default connect(
    mapStateToProps,
    null
)(SearchEventsView);
